














































































































































































import {Component} from 'vue-property-decorator';

import SelectorSite from '@/site/components/SelectorSite.vue';
import {ServiceLinks} from '@/site/interfaces';

import Account from './Account.vue';
import AffluenceModal from './AffluenceModal.vue';
import BaseService from './BaseService.vue';

@Component({components: {SelectorSite, AffluenceModal, Account}})
export default class AppBar extends BaseService {
  get servicesToShow(): ServiceLinks[] {
    if (this.$vuetify.breakpoint.mdAndDown) return this.services.slice(0, 3);
    if (this.$vuetify.breakpoint.lg) return this.services.slice(0, 4);
    return this.services.slice(0, 5);
  }

  get remainingServices(): ServiceLinks[] {
    return this.services.slice(this.servicesToShow.length);
  }
}
